import { render, staticRenderFns } from "./InventoryRooms.vue?vue&type=template&id=57213b49&"
import script from "./InventoryRooms.vue?vue&type=script&lang=ts&"
export * from "./InventoryRooms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports